import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const Progressbar = ({ ...rest }) => {
  return <LinearProgress {...rest} />;
};

export default Progressbar;
